import type React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isLoggedInSelector } from '../../redux/reducers/app/params';
import NetworkError from '../../utils/NetworkError';
import { UNAUTHORIZED as UNAUTHORIZED_ROUTE } from '../../constants/routeTemplates';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode | ((p: any) => React.ReactNode);
}

function PrivateRoute({ children, fallback, ...restProps }: Props) {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const loginFallback =
    fallback && typeof fallback === 'function' ? (
      fallback(restProps)
    ) : (
      <Redirect
        to={{
          pathname: UNAUTHORIZED_ROUTE,
          state: {
            error: { ...new NetworkError(401) },
          },
        }}
      />
    );

  return (
    <Route
      {...restProps}
      render={() => (isLoggedIn ? children : loginFallback)}
    />
  );
}

export default PrivateRoute;
